import { Fragment } from 'react';
import { Box } from '@material-ui/core';

import { TreeItem } from './TreeItem';

import { TreeBranch, RecursiveTreeProps } from './Tree.props';

/**
  RecursiveTree component.
 @returns {JSX.Element}
 */

export const RecursiveTree = ({ listMeta }: RecursiveTreeProps) => {
  const createTree = (branch: TreeBranch, level = 0) =>
    branch.branches && (
      <TreeItem id={branch.id} title={branch.title} branches={branch.branches} level={level}>
        {branch.branches.map((item: TreeBranch, index) => {
          return <Fragment key={`${item.id}-${index}`}>{createTree(item, level + 1)}</Fragment>;
        })}
      </TreeItem>
    );

  return (
    <Box>
      {listMeta.map((branch: TreeBranch, index: number) => (
        <Box key={index}>{createTree(branch)}</Box>
      ))}
    </Box>
  );
};
